module.exports = __webpack_public_path__ + "assets/img/bg-img-1.50874710.png";